import React from 'react'
import WrapperReactPage from '../General/WrapperReactPage'
import FilterResultsMovie from '../Overview/FilterResultsMovie'
import OverviewHero from './OverviewHero'
import MainSliderWrapper from '../PageFrontOverview/MainSliderWrapper'
import hasCloseEverythingIfNotActiveSelection from '../hoc/hasCloseEverythingIfNotActiveSelection'
import FilterResultsMovieArthouse from '../Overview/FilterResultsMovieArthouse'
import TrailerPopupWrapper from '../Trailer/TrailerPopupWrapper'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import getData from '../functions/getData'
import { ADVERTISEMENT_CONFIG, FEATURES, FRONT, PROGRAM_ADS, PROGRAM_ADVERTISEMENTS, PROGRAM_COLLECTIONS_ITEMS, PROGRAM_MOVIES, PROGRAM_SELECTIONS_ITEMS, PROGRAM_SELECTIONSDISPLAY, PROGRAM_WEISCHERADS, ROUTESDATA, THEME, TRANSLATION } from '../constants/state'

const mapStateToProps = (state, ownProps) => ({
    cinemaDataFront: getData(state, FRONT), 
    translation: getData(state, TRANSLATION),
    theme: getData(state, THEME),
    routesData: getData(state, ROUTESDATA), 
    features: getData(state, FEATURES),
    advertisements: getData(state, PROGRAM_ADVERTISEMENTS), 
    movies: getData(state, PROGRAM_MOVIES),
    weischerAds: getData(state, PROGRAM_WEISCHERADS), 
    itemCollections: getData(state, PROGRAM_COLLECTIONS_ITEMS), 
    itemSelections: getData(state, PROGRAM_SELECTIONS_ITEMS), 
    itemSelectionsDisplay: getData(state, PROGRAM_SELECTIONSDISPLAY), 
    ads: getData(state, PROGRAM_ADS),
    advertisementConfig: getData(state, ADVERTISEMENT_CONFIG),
})

const PageOverviewMovie = ({
    match, 
    movies, 
    routesData,
    weischerAds,
    advertisements,
    overviewHeroItems, 
    overviewHeroAdvertisementItems,
    features, 
    theme,
    translation,
    location,
    isOverviewPage,
    isScrolledClass,
    itemSelectionsDisplay,
    itemSelections,
    itemCollections,
    isConnectedFast,
    currentActiveSelection,
    setIdForActiveSelection,
    advertisementConfig,
    ads,
    cinemaDataFront
}) => {
    
    const {
        header_appearance,
        content_width,
        program_overview_list_style,
        show_availableIn,
        slider_appearance,
        program_overview_subtitle
    } = cinemaDataFront

    const {has_chatbot} = features
    const {theme_colors} = theme
    const {main_slider_advertisement_positioning} = advertisementConfig

    return (
        theme === 'Arthouse' ? (
            <WrapperReactPage hasChatbot={has_chatbot} headerAppearance={header_appearance} features={features} contentWidth={content_width} advertisements={advertisements} isScrolledClass={isScrolledClass} movies={movies} translation={translation}>
                {movies && movies.items && <FilterResultsMovieArthouse
                    match={match}
                    overviewSubtitle={program_overview_subtitle}
                    movies={movies}
                    location={location}
                    routesData={routesData}
                    weischerAds={weischerAds}
                    advertisements={advertisements}
                    theme={theme}
                    translation={translation}
                    moviesRoutesData={routesData.movies.items}
                />}
                <TrailerPopupWrapper/>
            </WrapperReactPage>
        ) : (
            <WrapperReactPage hasChatbot={has_chatbot} headerAppearance={header_appearance} features={features} contentWidth={content_width} advertisements={advertisements} isScrolledClass={isScrolledClass} movies={movies} translation={translation}>
                {movies && isOverviewPage && <MainSliderWrapper
                    itemSelectionsDisplay={itemSelectionsDisplay}
                    sliderAppearance={slider_appearance}
                    showAvailableIn={show_availableIn}
                    mainSliderAdvertisementPositioning={main_slider_advertisement_positioning}
                    itemSelections={itemSelections}
                    itemCollections={itemCollections}
                    ads={ads}
                    advertisements={advertisements}
                    weischerAds={weischerAds}
                    movies={movies.items}
                    theme={theme_colors}
                    moviesRoutesData={routesData.movies.items}
                    translation={translation}
                    currentActiveSelection={currentActiveSelection}
                    setIdForActiveSelection={setIdForActiveSelection}
                    features={features}
                    isConnectedFast={isConnectedFast}
                />}
                {!isOverviewPage && <OverviewHero
                    overviewHeroItems={overviewHeroItems}
                    overviewHeroAdvertisementItems={overviewHeroAdvertisementItems}
                    features={features}
                    movies={movies}
                />}
                {movies && movies.items && <FilterResultsMovie
                    match={match}
                    overviewSubtitle={program_overview_subtitle}
                    movies={movies}
                    location={location}
                    routesData={routesData}
                    programOverviewListStyle={program_overview_list_style}
                    weischerAds={weischerAds}
                    advertisements={advertisements}
                    translation={translation}
                />}
                <TrailerPopupWrapper/>
            </WrapperReactPage>
        )
    )
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(hasCloseEverythingIfNotActiveSelection(PageOverviewMovie))

